export default __webpack_public_path__ + "static/media/m_Burger_icon.ca9b82eb.svg";